export const DialogMessagesStatuses = {
    success: 'success',
    error: 'error',
    info: 'info',
}
